/* eslint-disable @typescript-eslint/naming-convention */

export enum ThemeType {
  lightBlue = 'Light Blue',
  cream = 'Cream',
  lightRed = 'Light Red',
  turqoise = 'Turqoise',
}
